import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.string.starts-with";
import i18next from 'i18next';
import { useMemo, useContext, useCallback } from 'react';
import { I18nContext } from './I18nProvider';

/**
 * Sets listner for language change,
 * returns currentLang language
 * and all languages list
 */
export function useLanguage() {
  var options = i18next.options;

  var _useContext = useContext(I18nContext),
      currentLang = _useContext.currentLang;

  var allLangs = options.supportedLngs.filter(function (lang) {
    return lang !== 'cimode';
  });
  var toLocalizedRoute = useCallback(function (link) {
    if (link && link.startsWith('/')) {
      if (allLangs.find(function (i) {
        return link.startsWith("/".concat(i));
      })) {
        return link;
      }

      if (currentLang) {
        return "/".concat(currentLang).concat(link);
      }
    }

    return link;
  }, [currentLang, allLangs]);
  return useMemo(function () {
    return {
      currentLang: currentLang,
      allLangs: allLangs,
      toLocalizedRoute: toLocalizedRoute
    };
  }, [currentLang, options.supportedLngs, toLocalizedRoute]);
}